<template>
    <div>
        <b-progress v-if="isBusy" :value="50" :max="100" animated></b-progress>
        <b-form-group class="mb-1 mt-1" v-if="items && items.length > 0">
            <b-input-group>
                <b-form-input :disabled="isBusy" size="sm" v-model="filter" placeholder="Filter"/>
                <b-input-group-append>
                    <b-btn size="sm" :disabled="!filter" @click="filter = ''">Clear</b-btn>
                </b-input-group-append>
            </b-input-group>
        </b-form-group>
        <b-table
                :items="items"
                responsive="sm"
                :sticky-header="(height - 80) + 'px'"
                small
                striped
                :filter="filter"
                :busy.sync="isBusy"
                :fields="fields"
        ></b-table>
    </div>
</template>

<script>

    export default {
        name: "Table",
        props: ["items", "height"],
        data() {
            return {
                isBusy: false,
                filter: '',
                fields: []
            }
        }

    }
</script>

<style scoped>

</style>
